var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "generalTemplateConfigurationModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.general_template_configuration"),
      },
      on: { show: _vm.loadConfigProperties },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateConfiguration()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.restoreDefaultTemplates()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("admin.restore_default_template")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("admin.template_override_description")))]),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("admin.template_override_file_hierarchy"))),
      ]),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("admin.template_override_security_warning"))),
      ]),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("admin.template_override_restart_needed"))),
      ]),
      _c(
        "b-form-group",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "template_override", color: "primary", label: "" },
                model: {
                  value: _vm.enableDefaultTemplatesOverride,
                  callback: function ($$v) {
                    _vm.enableDefaultTemplatesOverride = $$v
                  },
                  expression: "enableDefaultTemplatesOverride",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.enable_default_template_override")) +
              "\n  "
          ),
        ],
        1
      ),
      _c("b-validated-input-group-form-input", {
        attrs: {
          id: "template_basedir",
          label: _vm.$t("admin.template_basedir"),
          "input-group-size": "mb-3",
          rules: "required",
          type: "text",
          tooltip: _vm.$t("admin.template_basedir_tooltip"),
        },
        model: {
          value: _vm.templateBasedir,
          callback: function ($$v) {
            _vm.templateBasedir = $$v
          },
          expression: "templateBasedir",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }